import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { portalDocumentsApi } from '@/api/passengerDocuments';
import { Download, FileText, Image, Loader2 } from 'lucide-react';
function formatSize(bytes) {
    if (!bytes)
        return '—';
    if (bytes < 1024)
        return `${bytes} B`;
    if (bytes < 1024 * 1024)
        return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
function formatDate(dateStr) {
    if (!dateStr)
        return '—';
    return new Date(dateStr).toLocaleDateString('es-ES', { day: 'numeric', month: 'short', year: 'numeric' });
}
function FileIcon({ mimeType }) {
    if (!mimeType)
        return _jsx(FileText, { className: "w-5 h-5 text-gray-400" });
    if (mimeType.startsWith('image/'))
        return _jsx(Image, { className: "w-5 h-5 text-blue-500" });
    if (mimeType === 'application/pdf')
        return _jsx(FileText, { className: "w-5 h-5 text-red-500" });
    return _jsx(FileText, { className: "w-5 h-5 text-gray-400" });
}
export function PortalDocumentsSection({ token, tenantSlug }) {
    const [docs, setDocs] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        portalDocumentsApi.getMyDocuments(token, tenantSlug).then(data => {
            setDocs(data);
        }).catch(e => {
            console.error('Failed to load documents:', e);
        }).finally(() => {
            setLoading(false);
        });
    }, [token]);
    if (loading) {
        return (_jsx("div", { className: "flex justify-center py-8", children: _jsx(Loader2, { className: "w-6 h-6 animate-spin text-gray-400" }) }));
    }
    if (docs.length === 0) {
        return (_jsx("div", { className: "text-center py-8 text-gray-500 text-sm", children: "No tienes documentos disponibles" }));
    }
    return (_jsx("div", { className: "space-y-3", children: docs.map(doc => (_jsxs("a", { href: portalDocumentsApi.getDownloadUrl(doc.id, token, tenantSlug), target: "_blank", rel: "noreferrer", className: "flex items-center gap-4 p-4 bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow", children: [_jsx(FileIcon, { mimeType: doc.mimeType }), _jsxs("div", { className: "flex-1 min-w-0", children: [_jsxs("div", { className: "flex items-center gap-3 text-sm text-gray-900 mt-1", children: [_jsx("span", { children: doc.documentType?.name ?? 'Documento' }), _jsx("span", { children: formatSize(doc.size) }), _jsxs("span", { children: ["Subido ", formatDate(doc.uploadedAt)] }), doc.lastDownloadAt && (_jsxs("span", { className: "text-[var(--tenant-primary)]", children: ["Descargado ", formatDate(doc.lastDownloadAt)] }))] }), _jsx("p", { className: "text-sm font-medium text-gray-500 truncate", children: doc.fileName })] }), _jsx(Download, { className: "w-5 h-5 text-gray-400" })] }, doc.id))) }));
}
//# sourceMappingURL=PortalDocumentsSection.js.map